module.exports = __webpack_public_path__ + "img/04.d8512b6c.jpg";